export default __webpack_public_path__ + "static/media/image_person-risks.6ab8f377.png";